import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=e76a3660&scoped=true&"
import script from "./Judge.vue?vue&type=script&lang=js&"
export * from "./Judge.vue?vue&type=script&lang=js&"
import style0 from "./Judge.vue?vue&type=style&index=0&id=e76a3660&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76a3660",
  null
  
)

export default component.exports